export default {
  "content": "<g clip-path=\"url(#clip0)\"><path d=\"M40.5 78c20.987 0 38-17.013 38-38S61.487 2 40.5 2s-38 17.013-38 38 17.013 38 38 38z\" stroke=\"#ff00cb\" stroke-width=\"4\"/></g><path d=\"M36.5 48c4-4.148 16-16 16-16l-16 16zm0 0l-8-8\" stroke=\"#ff00cb\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><defs><clipPath id=\"clip0\"><path fill=\"#fff\" transform=\"translate(.5)\" d=\"M0 0h80v80H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "81",
    "height": "80",
    "viewBox": "0 0 81 80",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};